import React, { useEffect, useState, useRef } from "react";
import { Card, CardBody, CardHeader } from "./../../components/card/card.jsx";
import { useNavigate } from "react-router-dom";
import { alertV2, location } from "../../api";
import { dateToToday, formatDateOnly, printLocation } from "../../utils/helper";
import "bootstrap-daterangepicker/daterangepicker.css";
import { Loader } from "../../utils/helper";
import DataTable from "react-data-table-component";
import "bootstrap-daterangepicker/daterangepicker.css";
import Moment from "moment/moment";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { useAuth } from "../../contexts/AuthContext";
import { LocationFilter } from "../../components/LocationFilter/index.jsx";
import { useLocation } from "react-router-dom";

function MachineHealth() {
  let dataLocation = useLocation();
  const [locationData, setLocationData] = useState([]);
  const [selectedtedLocation, setSelectedtedLocation] = useState("");
  const [listAlarm, setListAlarm] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dateRangeCurrentWeek, setDateRangeCurrentWeek] = useState(
    Moment().subtract(7, "days").format("D MMM YYYY") +
      " - " +
      Moment().format("D MMM YYYY")
  );
  const [dateRangePrevWeek, setDateRangePrevWeek] = useState(
    Moment().subtract(15, "days").format("D MMM") +
      " - " +
      Moment().subtract(8, "days").format("D MMM YYYY")
  );
  const [selectedStatus, setSelectedStatus] = useState(
    dataLocation?.state?.status || ""
  );
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  function handleDateApplyEvent(event, picker) {
    var startDate = picker.startDate;
    var endDate = picker.endDate;
    var gap = endDate.diff(startDate, "days");
    setStartDate(startDate);
    setEndDate(endDate);
    var currentWeek =
      startDate.format("D MMM YYYY") + " - " + endDate.format("D MMM YYYY");
    var prevWeek =
      Moment(startDate).subtract(gap, "days").format("D MMM") +
      " - " +
      Moment(startDate).subtract(1, "days").format("D MMM YYYY");

    setDateRangeCurrentWeek(currentWeek);
    setDateRangePrevWeek(prevWeek);
  }
  const { config } = useAuth();
  async function getLocation() {
    const res = await location.list();
    if (res.ok) {
      const body = await res.json();
      let data = body.data;
      setLocationData(data);
    }
  }

  const handleChangeLocationFilter = (location_id) => {
    setSelectedtedLocation(location_id);
  };
  const handleChangeStatus = (status) => {
    setSelectedStatus(status);
  };

  function generateLocationWording() {
    let result = [];
    if (config && config?.location_wording) {
      const words = config?.location_wording.split(",");
      words.forEach((ln, index) => {
        result.push(ln);
      });
    }

    return result;
  }
  async function getAlarm() {
    try {
      let queryParam = {};
      queryParam = {
        start_date: startDate,
        end_date: endDate,
        status: selectedStatus,
        location_id: selectedtedLocation,
      };
      // remove query params that are empty
      Object.keys(queryParam).forEach(
        (key) => !queryParam[key] && delete queryParam[key]
      );
      const res = await alertV2.listByDate(queryParam);
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        setListAlarm(data);
        setLoading(false);
      }
    } catch (e) {
      setLoading(false);
      console.error(e);
    }
  }
  useEffect(() => {
    setLoading(true);
    getAlarm();
  }, []);
  useEffect(() => {
    getAlarm();
  }, [startDate, endDate, selectedStatus, selectedtedLocation]);
  const navigate = useNavigate();
  function handleDetail(id) {
    navigate("/alarm/detail/" + id);
  }
  const getStatus = (status) => {
    switch (status) {
      case "Acceptable":
        return "status-accept";
      case "Observe":
        return "status-observe";
      case "Alert":
        return "status-alert";
      case "Critical":
        return "status-critical";
      default:
        return "status-pending";
    }
  };

  const columns = [
    {
      name: "Alarm ID",
      width: "100px",
      maxWidth: "100px",
      selector: (row) => row.id,
    },
    {
      name: "Alarm Date",
      width: "110px",
      maxWidth: "110px",
      selector: (row) => row.machine_type.name,
      cell: (row) => <div>{formatDateOnly(row.max_date)}</div>,
    },
    {
      name: "Plant",

      width: "180px",
      maxWidth: "180px",
      selector: (row) =>
        row.deployment?.machine_element?.machine?.location?.parent_location
          ?.location_name,
      cell: (row) => (
        <div>
          {printLocation(
            row?.deployment?.machine_element?.machine?.location?.parent_location
              ?.location_name
          )}
        </div>
      ),
    },
    {
      name: "Area",
      width: "180px",
      maxWidth: "180px",
      selector: (row) =>
        row.deployment?.machine_element?.machine?.location?.location_name,
      cell: (row) => (
        <div>
          {printLocation(
            row?.deployment?.machine_element?.machine?.location?.location_name
          )}
        </div>
      ),
    },
    {
      name: "Machine Name",
      selector: (row) => row.deployment?.machine_element?.machine?.machine_name,
    },
    {
      name: "Status",
      width: "140px",
      maxWidth: "140px",
      selector: (row) => row.machine_type.name,
      cell: (row) => (
        <span
          className={
            row.alert_status?.toLowerCase() === "open"
              ? "status-open"
              : row.alert_status?.toLowerCase() === "closed"
              ? "status-close"
              : row.alert_status?.toLowerCase() === "invalid"
              ? "status-invalid"
              : "status-progress"
          }
        >
          {row.alert_status}
        </span>
      ),
    },
  ];

  const ExpandedComponent = ({ data }) => (
    <div style={{ padding: "10px" }}>
      <Card className="border-theme">
        <CardBody>
          <div>
            Alarm Finding : <b>{data.alert_finding}</b>
          </div>
          <button
            onClick={() => navigate("/alarm/detail/" + data.id)}
            type="button"
            className="btn btn-outline-theme"
          >
            View Detail
          </button>
        </CardBody>
      </Card>
    </div>
  );

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xl-12">
          <div className="row">
            <div className="col-xl-12">
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="#/">ALARM</a>
                </li>
                <li className="breadcrumb-item active">ALARM LIST</li>
              </ul>

              <h1 className="page-header">Alarm List</h1>

              <hr className="mb-4" />

              <div id="datatable" className="mb-5">
                <div className="row mb-2 justify-content-end">
                  <div className="col-3">
                    <LocationFilter onChange={handleChangeLocationFilter} />
                  </div>
                  <div className="col-3">
                    <select
                      value={selectedStatus}
                      onChange={(e) => handleChangeStatus(e.target.value)}
                      className="form-select  btn btn-sm btn-outline-theme"
                      defaultValue=""
                    >
                      <option value="">- Filter Status -</option>
                      <option value="Open">Open</option>
                      <option value="Invalid">Invalid</option>
                      <option value="Pending">Pending</option>
                      <option value="On Progress">On Progress</option>
                      <option value="Closed">Closed</option>
                    </select>
                  </div>

                  <div className="col-4">
                    <DateRangePicker
                      startDate={startDate}
                      endDate={endDate}
                      onApply={handleDateApplyEvent}
                    >
                      <button
                        className="btn btn-outline-theme text-truncate me-3 mb-2 mb-sm-0"
                        style={{ width: "100%" }}
                      >
                        <i className="fa fa-fw fa-calendar me-1"></i>
                        <span>{dateRangeCurrentWeek}</span>
                        <i className="fa fa-fw fa-caret-down me-n1"></i>
                      </button>
                    </DateRangePicker>
                  </div>
                </div>
                <div className="modal fade" id="modalLg">
                  <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                      <Card>
                        <CardHeader>Machine Alert Status</CardHeader>
                        <CardBody>
                          <div
                            style={{
                              width: "100%",
                              height: "50px",
                              borderRadius: "50px",
                              background:
                                "linear-gradient(90deg, rgba(175,234,205,1) 0%, rgba(175,234,205,1) 3%, rgba(234,228,175,1) 33%, rgba(255,190,126,1) 66%, rgba(255,119,156,1) 97%, rgba(255,119,156,1) 100%)",
                            }}
                          ></div>
                        </CardBody>
                      </Card>
                    </div>
                  </div>
                </div>
                <Card>
                  <CardBody>
                    <DataTable
                      highlightOnHover
                      expandOnRowClicked
                      expandableRowsHideExpander
                      expandableRows
                      expandableRowsComponent={ExpandedComponent}
                      theme="dark"
                      columns={columns}
                      data={listAlarm}
                      pagination
                    />
                  </CardBody>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MachineHealth;
